import { Link } from 'react-router-dom/cjs/react-router-dom';
import {
  ERROR_TYPE_ACCESS_DENIED,
  ERROR_TYPE_PASSWORD_EXPIRED,
  ERROR_TYPE_TOO_MANY_REQUESTS,
} from '../../../constants/errorTypes';

export function getSignInErrorMessage(error, username) {
  const remainingAttempts = Number(error.description);

  switch (error.type) {
    case ERROR_TYPE_ACCESS_DENIED:
      if (isNaN(remainingAttempts)) {
        return <>Wrong username or password</>;
      } else {
        return (
          <>
            Wrong username or password
            <br />
            {remainingAttempts} remaining attempts.
          </>
        );
      }

    case ERROR_TYPE_TOO_MANY_REQUESTS:
      return (
        <>
          User is locked due to {Number(error.description)} failed attempts.
          <br /> Please{' '}
          <a href="mailto:info@cym.bio" target="_blank" rel="noopener noreferrer">
            contact us
          </a>
        </>
      );

    case ERROR_TYPE_PASSWORD_EXPIRED:
      return (
        <>
          Password expired. Please{' '}
          <Link to={`/resetPassword?email=${encodeURIComponent(username)}`}>Reset your Password</Link>
        </>
      );

    default:
      return <>Authentication error</>;
  }
}
